module.exports = __webpack_public_path__ + "static/media/img1.bffcc3f4.svg";